const SOCIAL = [
  {
    key: 'mirror',
    label: 'Mirror',
    link: 'https://mirror.xyz/extrnode.eth',
  },
  {
    key: 'twitter',
    label: 'Twitter',
    variant: 'outline-dark',
    link: 'https://twitter.com/extrnode',
  },
  {
    key: 'discord',
    label: 'Discord',
    variant: 'dark',
    link: 'https://discord.gg/mb2xQ7kgdq',
  },
]

export default SOCIAL
